<template>
    <div style="margin: 0; padding: 0; width: 100%; display: flex; flex-direction: column;">
        <h1 class="mb-3 blue--text" style="margin-left: 0;"> {{$t('pmselfservice.kpirecords')}}</h1>
        <!-- Loop through KPIList-->
        <v-container fluid class="mt-8">
            <v-row dense>
                <v-col
                v-for="(kpi, index) in KPIList"
                :key="index"
                :cols="colSize"
                >
                <v-card outlined elevation="2" style="max-height: 200px; overflow: auto; color: black;">
                    <v-card-title class="green--text text-subtitle-2" style="font-size: 14px;">
                    <b>{{ kpi.status }}</b>
                    </v-card-title>
                    
                    <div class="blue--text text-body-2 ml-4 mb-1" style="font-size: 14px; line-height: 1.2;">
                    <b>{{ kpi.title }}</b>
                    </div>

                    <div class="text-body-2 ml-4 mb-1" style="font-size: 14px; line-height: 1.2;">
                    <b>{{ kpi.description }}</b>
                    </div>

                    <div class="text-body-2 ml-4 mb-1" style="font-size: 14px; line-height: 1.2;">
                    <b>{{ kpi.startdate }}</b> {{$t('until')}} <b>{{ kpi.enddate }}</b>
                    </div>

                    <div class="text-body-2 ml-4 mb-1" style="font-size: 14px; line-height: 1.2;">
                    {{$t('appraisalrecord.reviewer')}}: <b>{{ kpi.reviewername }}</b>
                    </div>

                    <v-card-actions class="justify-end mt-1">
                    <v-btn color="primary" @click="viewDetails(kpi)">
                        {{$t('pmmoderation.viewdetails')}}
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>



<script>

import moment from 'moment';

export default {
    data() {
        return {
            KPIList: [],
        };
    },

    computed: {
        colSize() {
            const count = this.KPIList.length;
            if (count === 1) return 12;  // full row
            if (count === 2) return 6;   // half row each
            return 4;                    // 3 per row
        }
    },

    methods: {
        chunkArray(array, size) {
            const chunks = [];
            for (let i = 0; i < array.length; i += size) {
                chunks.push(array.slice(i, i + size));
            }
            return chunks;
        },
        viewDetails(kpi) {
            console.log("KPI: ", kpi);
            this.$router.push({ name: "selfservicekpidetails", params: { kpi : kpi} });
        },

        loadKPIList() {
            const vm = this;
            this.$store.dispatch('get', {url: "/kpiexercise/staff/list/" + this.$store.getters.staffId})
            .then(function (res) {
                for (let i = 0; i < res.data.rec.length; i++) {
                    if (res.data.rec[i].startdate) {
                        res.data.rec[i].startdate = moment(res.data.rec[i].startdate).format('DD-MM-YYYY');
                    }
                    if (res.data.rec[i].enddate) {
                        res.data.rec[i].enddate = moment(res.data.rec[i].enddate).format('DD-MM-YYYY');
                    }
                }
                vm.KPIList = res.data.rec;
                console.log("KPI List: ", vm.KPIList);
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },
    },

    mounted() {
        this.loadKPIList();
        console.log("ID: ", this.$store.getters.staffId);
        console.log("INFO", this.$store.getters);
    },    
};

</script>

<style scoped>

</style>